import { commitmentsRecommendationsSelector } from "./commitmentsRecommendationsSelector";
import { RootState } from "../../../../store";

export const commitmentsRecommendationsLoadingSelector = (state: RootState) => {
  const response = commitmentsRecommendationsSelector(state);

  return response?.isLoading;
};
